export default __webpack_public_path__ + "static/media/patientDisplaysAggression.a7c19390.svg";